import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/heart-rate-zones',
  component: () => import('../../routes/HeartRateZones.svelte'),
  card: {
    id: 'heart-rate-zones',
    title: 'Heart Rate Zone Calculator',
    description: 'Calculate your personalized training zones using the Karvonen formula. Find your fat burn, cardio, and peak heart rate zones for optimized workouts.',
    icon: 'favorite',
    iconBgClass: 'bg-red-50',
    iconTextClass: 'text-red-600',
    href: '/heart-rate-zones',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Heart Rate Zone Calculator – Karvonen Formula Training Zones',
    description: 'Free heart rate zone calculator using the Karvonen formula. Calculate your fat burn, cardio, and peak training zones based on your age, resting heart rate, and fitness level. Includes 5 workout zones for optimal training.',
  },
};

export default meta;
